import React, { Suspense } from "react";
import { colors } from "../../colors";

const LazyCLientLanding = React.lazy(() => import("./landing"));

export const ClientLandingRouter = () => {
  return (
    <Suspense
      fallback={<div style={{ width: "100vw", height: "100vh", backgroundColor: colors.memberBg }}></div>}
    >
      <LazyCLientLanding />
    </Suspense>
  );
};
